const RESIZE_EVENT_NAME = 'resize-event';

export default RESIZE_EVENT_NAME;
